export class ExportableClass {
  toDict (): Object {
    return JSON.parse(JSON.stringify(this))
  }
}

export interface KeyDict<T> {
  [id: string]: T
}

export type DeepPartial<T> = {
    [P in keyof T]?: DeepPartial<T[P]>;
}

export interface MenuItem {
  label: string,
  action: string,
  icon: string
}

export interface SelectOption {
  key: string
  label: string
  disabled?: boolean
}
export interface ErrorMessage {
  message: string
  hint?: string
}

export enum TalkbackMode {
  Global = 'Global',
  Custom = 'Custom'
}

export enum CollectionNames {
  ADMIN = 'admin',
  ASSETS = 'assets',
  ASSET_GROUPS = 'asset-groups',
  CASTS = 'casts',
  CAST_TEMPLATES = 'cast_templates',
  CHATS = 'chats',
  EVENTS = 'events',
  INVITES = 'invites',
  LAYOUTS = 'layouts',
  PROFILES = 'profiles',
  STREAMS = 'streams',
  TEAMS = 'teams',
  TEAMS_ROLES = 'teams_roles',
  VIDEO_PLAYER = 'videoplayer',
  WIDGETS = 'widgets'
}

export enum AdminDocNames {
  CLOUDCAST_MANAGER_DATA = 'cloudcast_manager_data',
  FEATURE_FLAGS = 'featureflags',
  RELEASE = 'release',
  STREAMS_AUTH = 'streams_auth'
}

export enum SocialMedia {
  Facebook = 'facebook',
  Youtube = 'youtube',
  Periscope = 'periscope',
  Twitch = 'twitch'
}
